<template>
  <TextInput
    v-model="searchTerm"
    :label="label"
    :is-loading="isSearching"
    :html-id="`${htmlId}-input`"
  />
</template>

<script lang="ts">
import TextInput from "./inputs/TextInput.vue"
import { defineComponent } from "vue"

/** 
 * A text input field that triggers `search` event after a timeout.
 */
export default defineComponent({
  components: {
    TextInput
  },
  props: {
    /** How long to wait after the user stops typing before sending the `search` event */
    timeout: {
      type: Number,
      default: 300
    },
    /** Show a loading spinner on the input */
    isSearching: {
      type: Boolean,
      default: false
    },
    /** The label of the field */
    label: {
      type: String
    },
    /** The ID for the field, gets suffixed with `-input` */
    htmlId: {
      type: String
    }
  },
  data() {
    return {
      searchTerm: "",
      debouncer: null
    }
  },
  watch: {
    searchTerm() {
      let later = () => {
        this.debouncer = null
        /** Triggers after the timeout, sends the input string */
        this.$emit("search", this.searchTerm)
      }
      clearTimeout(this.debouncer)
      this.debouncer = setTimeout(later, this.timeout)
    }
  }
})
</script>